import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * ProtectedRoute component that enforces role-based access control
 * @param {Array<string>} allowedRoles - Array of roles that can access this route (e.g., ["Admin", "Member"])
 * @param {React.Component} children - The component to render if access is granted
 */
const ProtectedRoute = ({ allowedRoles, children }) => {
  const { currentUser } = useAuth();
  
  // If user is not logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If allowedRoles is not specified, allow access to all authenticated users
  if (!allowedRoles || allowedRoles.length === 0) {
    return children;
  }

  // Check if user's role is in the allowed roles
  const hasAccess = allowedRoles.includes(currentUser.Role);

  // If user doesn't have the required role, redirect to 404
  if (!hasAccess) {
    return <Navigate to="/404" replace />;
  }

  // User has access, render the component
  return children;
};

export default ProtectedRoute;
